// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    name: 'g-breadcrumb',
    props: {
        showHome: {
            type: Boolean,
            required: false,
            default: true
        },
    },
});
// #endregion
